declare const window: any;

export const crmSearchAndOpenRecords = (type: string, queryString: string, searchOnly: boolean) => {
  if (window.Microsoft && window.Microsoft.CIFramework) {
    return window.Microsoft.CIFramework.searchAndOpenRecords(type, queryString, searchOnly);
  }
};
